import React, { Suspense, useEffect, useRef, useState, useMemo, useContext } from "react";
import "./App.css";
import {
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
  UNSAFE_RouteContext,
  UNSAFE_NavigationContext,
} from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import "react-phone-input-2/lib/style.css";
import "react-quill/dist/quill.snow.css";
import "./scss/main.scss";
import { ToastContainer } from "react-toastify";
import { lazy } from "react";
import { useDispatch, useSelector } from "react-redux";
import { chats_saver } from "./Pages/actions/chats";
import { MdCallEnd } from "react-icons/md";
import AudioCallRingModal from "./components/CommonModals/AudioCallModal";
import VideoCallRingModal from "./components/CommonModals/VideoCallModal";
import socketModel from "./models/socketModel";
import environment from "./environment";
import { audio_modal, video_modal } from "./Pages/actions/video_audio_modal";
import { SidebarProvider } from "./SidebarContext";
import { encryptPath, decryptRouteParam } from "./utils/cryptoHelper";

const RouteContextProvider = UNSAFE_RouteContext.Provider;
const NavigationContextProvider = UNSAFE_NavigationContext.Provider;

const lazyCache: Record<string, React.LazyExoticComponent<any>> = {};

const getLazyComponent = (path: string) => {
  if (!lazyCache[path]) {
    lazyCache[path] = lazy(() => import(`./Pages/${path}`));
  }
  return lazyCache[path];
};

const PageRoute = ({ CallingUserName, children, CallingUserData }: any) => {
  const user: any = useSelector((state: any) => state.user);
  const history = useNavigate();
  const location = useLocation();

  const routeContext: any = useContext(UNSAFE_RouteContext);
  const decryptedRouteContext = useMemo(() => {
    if (!routeContext?.matches || routeContext.matches.length === 0) {
      return routeContext;
    }
    const matches = routeContext.matches.map((m: any, idx: number) => {
      if (idx !== routeContext.matches.length - 1 || !m.params) return m;
      const decryptedParams: Record<string, string> = {};
      for (const [k, v] of Object.entries(m.params)) {
        decryptedParams[k] = v ? decryptRouteParam(v as string) : (v as string);
      }
      return { ...m, params: decryptedParams };
    });
    return { ...routeContext, matches };
  }, [routeContext]);

  useEffect(() => {
    const rawPath = location.pathname + location.search + location.hash;
    const encrypted = encryptPath(rawPath);
    if (encrypted !== rawPath) {
      window.history.replaceState(window.history.state, '', encrypted);
    }
  }, [location.pathname, location.search, location.hash]);
  let VoiceCall: any = localStorage.getItem("BackToVoiceCall");
  let VideoCall: any = localStorage.getItem("BackToVedioCall");

  const CHATS = useSelector((state: any) => state.chats?.data)
  const GoOnCall = () => {
    if (VoiceCall) {
      VoiceCall = JSON.parse(VoiceCall)
      history(`/chat?room_idd=${VoiceCall?.room_id}&voiceCall=true`)
    }
    if (VideoCall) {
      VideoCall = JSON.parse(VideoCall)
      history(`/chat?room_idd=${VideoCall?.room_id}&videoCall=true`)
    }

  }

  const LocalStorageRemover = () => {
    localStorage.removeItem('BackToVedioCall')
    localStorage.removeItem('BackToVoiceCall')
  }
  const CallEndHandler = () => {
    let VoiceCall: any = localStorage.getItem("BackToVoiceCall");
    let VideoCall: any = localStorage.getItem("BackToVedioCall");
    const Data: any = VoiceCall ? JSON.stringify(VoiceCall) : JSON.stringify(VideoCall);
    if (Data?.room_id) {
      const RoomDetails = CHATS?.find((_i: any) => _i?.room_id == Data?.room_id);
      if (RoomDetails?.isGroupChat || CallingUserData?.isGroupChat) {
        try {
          const credentials = btoa(
            `${environment?.customerId}:${environment?.customerSecret}`
          );
          fetch(
            `https://api.agora.io/dev/v1/channel/user/${environment.appId}/${Data?.room_id || CallingUserData?.room_id}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Basic ${credentials}`, // Add Basic Auth header
              },
            }
          )
            .then((response) => response.json())
            .then((data) => {
              if (
                ((!data?.data?.channel_exist || data?.data?.users?.length < 2))) {
                socketModel.emit("stop-voice-call", {
                  room_id: Data?.room_id || CallingUserData?.room_id,
                  user_id: user?.id,
                });
              }
            })
            .catch((error) => console.error("Error:", error)).finally(() => {
              LocalStorageRemover()
              window.location.reload();
            })
        } catch {
          console.log('Error while ending the call')
        }
      } else {
        LocalStorageRemover()
        window.location.reload();
      }
    } else {
      LocalStorageRemover();
      window.location.reload();
    }
  }

  return (
    <RouteContextProvider value={decryptedRouteContext}>
      {(VoiceCall && !window.location.pathname?.includes('/chat')) ? (
        <div className="flex justify-between bg-[#cfd3e9] p-[4px_16px]" onClick={GoOnCall}>
          <div></div>
          <div>
            <p className="">{CallingUserName?.name}</p>
          </div>
          <div className="text-[red] bg-[#e5d5d5] p-[1px_5px] rounded-full">
            <MdCallEnd onClick={() => CallEndHandler()} />
          </div>
        </div>
      ) : (
        <></>
      )}
      {children}
    </RouteContextProvider>
  );
}

function App() {

  const user: any = useSelector((state: any) => state.user);
  const [CallingUserData, setCallingUserData] = useState({})
  const [CallingUserName, setCallingUserName] = useState({})
  const reduxData = useSelector((state: any) => state);
  const ModalSettings = useSelector((state: any) => state.call_modal)
  const ROOMIDS = useSelector((state: any) => state.chats?.roomids)
  const CHATS = useSelector((state: any) => state.chats?.data)
  const [VideoModal, setVideoModal] = useState<boolean>(false);
  const [AudioModal, setAudioModal] = useState<boolean>(false);
  const CurrentRoomId = useRef(null)

  const navContext: any = useContext(UNSAFE_NavigationContext);
  const encryptedNavigator = useMemo(() => {
    if (!navContext?.navigator) return navContext?.navigator;
    return {
      ...navContext.navigator,
      push(to: any, state: any, opts: any) {
        return navContext.navigator.push(encryptPath(to), state, opts);
      },
      replace(to: any, state: any, opts: any) {
        return navContext.navigator.replace(encryptPath(to), state, opts);
      },
      createHref(to: any) {
        return navContext.navigator.createHref(encryptPath(to));
      },
      encodeLocation(to: any) {
        return navContext.navigator.encodeLocation
          ? navContext.navigator.encodeLocation(encryptPath(to))
          : encryptPath(to);
      },
    };
  }, [navContext]);

  const navigationContextValue = useMemo(() => {
    return {
      ...navContext,
      navigator: encryptedNavigator,
    };
  }, [navContext, encryptedNavigator]);

  const dispatch: any = useDispatch();
  useEffect(() => {
    dispatch(chats_saver()(user));
    sessionStorage.clear();
  }, [])

  const routes = [
    { url: "/login", path: "Login" },
    { url: "/dashboard", path: "Dashboard" },
    { url: "*", path: "NotFoundPage" },
    { url: "/profile", path: "Profile" },
    { url: "/profile/:tab", path: "Settings" },
    { url: "/forgotpassword", path: "Forgotpassword" },
    { url: "/otp-verify", path: "Forgotpassword/OTPverify/html" },
    { url: "/resetpassword", path: "Resetpassword" },
    { url: "/user", path: "Users" },
    { url: "/user/edit/:id", path: "Users/AddEdit" },
    { url: "/user/add", path: "Users/AddEdit" },
    { url: "/user/detail/:id", path: "Users/View" },
    { url: "/", element: <Navigate to="/login" /> },
    { url: "/chat", path: "Chat" },
    { url: "/content", path: "ContentManagement" },
    { url: "/content/detail/:id", path: "ContentManagement/View" },
    { url: "/content/edit/:id", path: "ContentManagement/AddEdit" },
    { url: "/customers", path: "Customers" },
    { url: "/customers/edit/:id", path: "Customers/AddEdit" },
    { url: "/customers/add", path: "Customers/AddEdit" },
    { url: "/customers/detail/:id", path: "Customers/View" },
    { url: "/contract", path: "Contract" },
    { url: "/contract/detail/:id", path: "Contract/View" },
    { url: "/plans", path: "Plans" },
    { url: "/plans/add", path: "Plans/AddEdit" },
    { url: "/plans/edit/:planid/:copy", path: "Plans/AddEdit" },
    { url: "/plans/detail/:id", path: "Plans/Detail" },
    { url: "/feature", path: "Features" },
    { url: "/feature/edit/:id", path: "Features/AddEdit" },
    { url: "/feature/add", path: "Features/AddEdit" },
    { url: "/feature/detail/:id", path: "Features/View" },
    { url: "/carriers", path: "Carrier" },
    { url: "/carriers/edit/:id", path: "Carrier/AddEdit" },
    { url: "/carriers/add", path: "Carrier/AddEdit" },
    { url: "/carriers/detail/:id", path: "Carrier/View" },
    { url: "/acceptedcarriers", path: "Carrier/AcceptedCarrier" },
    { url: "/rejectedcarriers", path: "Carrier/RejectedCarrier" },
    { url: "/carriersrequest", path: "Carrier/CarriersRequest" },
    { url: "/carrierstaff", path: "Carrier/CarrierStaff" },
    { url: "/carrierstaff/edit/:id", path: "Carrier/AddEditStaff" },
    { url: "/approvedSubCarrier", path: "Carrier/ApprovedSubCarrier" },
    { url: "/transaction", path: "Transaction" },
    { url: "/transaction/detail/:id", path: "Transaction/Detail" },
    { url: "/admin/payments/pending", path: "PendingPayments" },
    { url: "/pending-payments", path: "PendingPayments" },
    { url: "/admin/payments/approved", path: "ApprovedPayments" },
    { url: "/approved-payments", path: "ApprovedPayments" },
    { url: "/trucks", path: "Truck" },
    { url: "/trucks/add", path: "Truck/AddTruck" },
    { url: "/trucks/edit/:id", path: "Truck/AddTruck" },
    { url: "/trucks/detail/:id", path: "Truck/View" },
    { url: "/drivers", path: "Driver" },
    { url: "/drivers/edit/:id", path: "Driver/AddEdit" },
    { url: "/drivers/add", path: "Driver/AddEdit" },
    { url: "/drivers/detail/:id", path: "Driver/View" },
    { url: "/driverrequest", path: "Driver/DriverRequest" },
    { url: "/staff", path: "Staff" },
    { url: "/staff/edit/:id", path: "Staff/AddEdit" },
    { url: "/staff/add", path: "Staff/AddEdit" },
    { url: "/staff/detail/:id", path: "Staff/View" },
    { url: "/groups", path: "Group" },
    { url: "/groups/edit/:id", path: "Group/AddEdit" },
    { url: "/groups/add", path: "Group/AddEdit" },
    { url: "/groups/detail/:id", path: "Group/View" },
    { url: "/loads", path: "Loads" },
    { url: "/loads/edit/:id", path: "Loads/AddEdit" },
    { url: "/loads/add", path: "Loads/AddEdit" },
    { url: "/loads/detail/:id", path: "Loads/View" },
    { url: "/pickeduploads", path: "Loads/PickedupLoads" },
    { url: "/intransitloads", path: "Loads/IntransitLoads" },
    { url: "/deliveredloads", path: "Loads/DeliveredLoads" },
    { url: "/pendingpickuploads", path: "Loads/PendingPickupLoads" },
    { url: "/tasks/edit/:id", path: "Tasks/AddEditTask" },
    { url: "/tasks/add", path: "Tasks/AddEditTask" },
    { url: "/tasks", path: "Tasks" },
    { url: "/tasks/detail/:id", path: "Tasks/View" },
    { url: "/department/edit/:id", path: "Department/AddEdit" },
    { url: "/department/add", path: "Department/AddEdit" },
    { url: "/department", path: "Department" },
    { url: "/department/detail/:id", path: "Department/View" },
    { url: "/shipmentnotes", path: "ShipmentNotes" },
    { url: "/shipmentnotes/detail/:id", path: "ShipmentNotes/View" },
    { url: "/query", path: "Query" },
    { url: "/query/detail/:id", path: "Query/View" },
    { url: "/notification", path: "Notification" },
    { url: "/notification/detail/:id", path: "Notification/View" },
  ];

  useEffect(() => {
    setVideoModal(ModalSettings?.video_modal)
  }, [ModalSettings?.video_modal])
  useEffect(() => {
    setAudioModal(ModalSettings?.audio_modal)
  }, [ModalSettings?.audio_modal])
  const RoomIdDetector = (data: any, type: 'Video' | 'Audio', resp: boolean) => {
    let roomId = data?.data?.room_id
    if (ROOMIDS.includes(roomId)) {
      DetailsFinder(data?.data?.user_id, roomId);
      socketModel.emit('join-room', { room_id: data?.data?.room_id, user_id: user?._id || user?.id, })
      if (!resp && CurrentRoomId.current !== roomId) {
        return
      }
      CurrentRoomId.current = roomId
      if (type == 'Video') {

        if (!(user?.id == data?.data?.user_id)) {
          if (window.location.pathname?.includes('/chat')) {
          } else {
            setVideoModal(resp);
            dispatch(video_modal(resp));
          }

        }
      } else {
        if (!(user?.id == data?.data?.user_id)) {
          if (window.location.pathname?.includes('/chat')) {
          } else {
            setAudioModal(resp);
            dispatch(audio_modal(resp));
          }
        }

      }
    }

  }
  const DetailsFinder = (id: any, room_Id: any) => {
    const RoomDetails = CHATS?.find((_i: any) => _i?.room_id == room_Id);
    const AllRoomMembers = RoomDetails?.room_members || [];
    const userData = AllRoomMembers?.find((_data: any) => _data?.user_id == id);
    if (userData) {
      if (RoomDetails?.isGroupChat) {
        setCallingUserName({ name: userData?.room_name })
        setCallingUserData({ ...userData, ...RoomDetails, name: `${userData?.user_name} calling in ${RoomDetails?.room_name} group`, user_image: RoomDetails?.room_image });
      }
      else {
        setCallingUserName({ name: userData?.user_name })
        setCallingUserData({ ...userData, ...RoomDetails, name: `${userData?.user_name} is calling....` });
      }
    }
  }
  useEffect(() => {


    socketModel.on("recieve-voice-call", (data: any) => {
      // alert('Listening for voice')
      RoomIdDetector(data, 'Audio', true)
    })
    socketModel.on("recieve-video-call", (data: any) => {
      RoomIdDetector(data, 'Video', true)
    })

    socketModel.on("stop-video-call", (data) => {
      RoomIdDetector(data, 'Video', false)
    })
    socketModel.on("stop-voice-call", (data) => {
      RoomIdDetector(data, 'Audio', false)
    })
  }, [])

  useEffect(() => {
    dispatch(video_modal(false));
    dispatch(audio_modal(false));
  }, [])


  return (
    <NavigationContextProvider value={navigationContextValue}>
      <SidebarProvider>
        <Suspense
        fallback={
          <div  className="loaderDiv d-none">
            <div>
              <img
                src="/assets/img/loader.gif"
                alt="logo"
                className="loaderlogo"
              />
            </div>
          </div>
        }
      >


        <Routes>
          {routes.map((itm) => {
            const Element = itm.path ? getLazyComponent(itm.path) : null;
            return (
              <Route
                key={itm.url}
                path={itm.url}
                element={
                  Element ? (
                    <PageRoute CallingUserData={CallingUserData} CallingUserName={CallingUserName}>
                      <Element />
                    </PageRoute>
                  ) : (
                    itm.element
                  )
                }
              />
            );
          })}
        </Routes>

      </Suspense>
      </SidebarProvider>


      <div id="loader" className="loaderDiv d-none">
        <div>
          <img src="/assets/img/loader.gif" alt="logo" className="loaderlogo" />
        </div>
      </div>
      <ToastContainer position="top-right" />
      {/*  Headless UI MODAL FOR VIDEO AND AUDIO CALL */}
      <AudioCallRingModal isOpen={AudioModal} setIsOpen={setAudioModal} roomId={CurrentRoomId.current} CallingUserData={CallingUserData} />
      <VideoCallRingModal isOpen={VideoModal} setIsOpen={setVideoModal} roomId={CurrentRoomId.current} CallingUserData={CallingUserData} />
    </NavigationContextProvider>
  );
}

export default App;
